// src/utils/usePageLifecycle.js

import { useEffect } from 'react';

export const usePageLifecycle = (callbacks = {}) => {
  useEffect(() => {
    const {
      onFreeze,
      onResume,
      onHidden,
      onVisible
    } = callbacks;

    // Page Lifecycle API - handles browser suspension states
    const handleFreeze = () => {
      // Page is being frozen (suspended)
      // console.log('Page freezing - browser suspending execution');
      if (onFreeze) onFreeze();
    };

    const handleResume = () => {
      // Page is being resumed from frozen state
      // console.log('Page resuming from frozen state');
      if (onResume) onResume();
    };

    // Visibility change handler
    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (onHidden) onHidden();
      } else {
        if (onVisible) onVisible();
      }
    };

    // Page hide event (more reliable than visibilitychange for some cases)
    const handlePageHide = (event) => {
      if (event.persisted) {
        // Page is being cached (back/forward cache)
        // console.log('Page entering back/forward cache');
      }
    };

    const handlePageShow = (event) => {
      if (event.persisted) {
        // Page restored from back/forward cache
        // console.log('Page restored from cache');
        if (onResume) onResume();
      }
    };

    // Add all event listeners
    document.addEventListener('freeze', handleFreeze);
    document.addEventListener('resume', handleResume);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('pageshow', handlePageShow);

    // Initial visibility check
    if (document.hidden && onHidden) {
      onHidden();
    }

    return () => {
      document.removeEventListener('freeze', handleFreeze);
      document.removeEventListener('resume', handleResume);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', handlePageHide);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [callbacks]);
};